import {Component, Inject, OnInit} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {UserAddRequest} from 'src/app/model/user-add-request';
import {UserService} from 'src/app/service/user.service';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {Router} from '@angular/router';
import {NotificationService} from './../../service/notification.service';
import {DatePipe} from '@angular/common';
import {PortalRolesRequest} from 'src/app/model/portal';
import {ClientService} from "../../service/client.service";
import {Client} from "../../model/client";

@Component({
  selector: 'app-adduser',
  templateUrl: './add-user.component.html',
  styleUrls: ['./add-user.component.scss']
})
export class AddUserComponent implements OnInit {
  userForm: FormGroup;
  nursePractitionerFormEnabled: boolean = false;
  salesFormEnabled: boolean = false;
  clientsList: Client[];
  portals: Array<Object> =
    [
      { value: "SCHEDULER", name: "SCHEDULER" },
      { value: "PROVIDER", name: "PROVIDER" },
      { value: "CODER", name: "CODER" },
      { value: "IAM", name: "IDENTITY & ACCESS MANAGEMENT(IAM)" },
      { value: "SALES", name: "SALES" },
    ];
  displayRoles: any[] = [];
  allRoles: any[] = [];
  roles: any[] = [];
  userAddRequest = new UserAddRequest();
  portalRolesRequest = new PortalRolesRequest();

  role: string;
  minDate = new Date();
  maxDate = new Date();
  emailModel: '';
  enableReset: boolean = false;

  constructor(
    private formBuilder: FormBuilder,
    private userService: UserService,
    private _clientService: ClientService,
    private datePipe: DatePipe,
    private _notificationService: NotificationService,
    private _formBuilder: FormBuilder,
    private _router: Router,
    public dialogRef: MatDialogRef<AddUserComponent>,
    @Inject(MAT_DIALOG_DATA) public data: UserAddRequest) { }


  ngOnInit(): void {
    this.userForm = this.formBuilder.group({
      employeeId: [],
      clientId: [],
      firstName: [, [Validators.required]],
      lastName: [, [Validators.required]],
      email: [, [Validators.required, Validators.email]],
      confirmEmail: [],
      phoneNumber: [, [Validators.required]],
      effectiveDate: [this.userAddRequest.effectiveDate, [Validators.required]],
      terminationDate: [this.userAddRequest.terminationDate, [Validators.required]],
      timeZone: [],
      otpPreference: [, [Validators.required]],
      roles: [],
      portals: [],
      licensedState: [],
      licensedStartDate: [this.userAddRequest.licensedStartDate],
      licensedExpiryDate: [this.userAddRequest.licensedExpiryDate],
      serviceAddress1: [],
      serviceAddress2: [],
      serviceCity: [],
      serviceState: [],
      serviceZip: [],
      npi: [],
      address1: [],
      address2: [],
      city: [],
      state: [],
      zip: [],
      title : [],
    })
    this.userService.getRoles()
      .subscribe(data => {
        if (!data) {
          return;
        }
        this.allRoles = data.roles;
      });
  }

  showNpForm(event: {
    isUserInput: any;
    source: { value: any; selected: any };
  }) {
    if (event.isUserInput) {
      if (event.source.selected === true) {
        if (event.source.value == 3) {
          this.nursePractitionerFormEnabled = true;
        }
        if (event.source.value == 11) {
          this.salesFormEnabled = true;
          this.loadClients();
        }
      } else {
        if (event.source.value == 3) {
          this.nursePractitionerFormEnabled = false;
        }
        if (event.source.value == 11) {
          this.salesFormEnabled = false;
        }
      }
    }
  }

  addUser() {
    this.userAddRequest = this.userForm.value;
    this.userAddRequest.effectiveDate = this.datePipe.transform(this.userForm.get('effectiveDate').value, "yyyy-MM-dd");
    this.userAddRequest.terminationDate = this.datePipe.transform(this.userForm.get('terminationDate').value, "yyyy-MM-dd");
    this.userAddRequest.licensedStartDate = this.datePipe.transform(this.userForm.get('licensedStartDate').value, "yyyy-MM-dd");
    this.userAddRequest.licensedExpiryDate = this.datePipe.transform(this.userForm.get('licensedExpiryDate').value, "yyyy-MM-dd");
    this.userService.addUser(this.userAddRequest)
      .subscribe(data => {
        if (!data) {
          return;
        }
        console.log(data);
        this.dialogRef.close(this.userForm.value);
        if (data.successFlag) {
          this._notificationService.success('User added successfully');
        }else if(data.errorCode == 'EXISTING_USER_EXCEPTION'){
            this._notificationService.error(data.errorMsg);
          }else if(data.errorCode == 'MANDATORY_FIELD_EMPTY_EXCEPTION'){
            this._notificationService.error(data.errorMsg);
          } else {
          this._notificationService.error('User add failed / Please fill all the mandatory fields');
        }
      }, error => console.log(error));
  }

  dateChanged({ value }) {
    if (value) {
      this.maxDate = value;
      this.userForm.get('terminationDate').setValue(value + 30);
    }
  }

  deleteUnsupportedChars(event: any) {
    event.target.value = event.target.value.replace(/[^0-9]/g, "");
    event.target.dispatchEvent(new Event('input'));
  }

  keyPress2(event: any) {
    const pattern = /[A-Z\ a-z \+\-\ ]/;
    let inputChar = String.fromCharCode(event.charCode);
    if (event.keyCode != 5 && !pattern.test(inputChar)) {
      event.preventDefault();
    }
  }

  getRolesByPortal({ value }) {
    //alert(value);
    this.displayRoles = [];
    this.getRoles(value)
  }

  getRoles(portals: any[]) {
    this.portalRolesRequest.portals = portals;
    this.userService.getPortals(this.portalRolesRequest)
      .subscribe(data => {
        if (!data) {
          return;
        }
        console.log(data);
        if (data.successFlag) {
          data.roles.filter(item => {
            this.allRoles.filter(role => {
              if (role.id == item) {
                this.displayRoles.push(role)
              }
            })
          })
        }
      }, error => console.log(error));
  }

  rolesSelected(panelOpen: boolean){
    if (!panelOpen) {
      this.enableReset = true;
    }
  }

  changeResetButton(){
    this.enableReset = false;
    this.userForm.get('portals').setValue([]);
    this.userForm.get('roles').setValue([]);
    this.nursePractitionerFormEnabled = false;
    this.salesFormEnabled = false;
  }

  loadClients(): void {
    this._clientService.getClients()
      .subscribe(result => {
        if (!result) {
          return;
        }
        this.clientsList = result.clients;
      });
  }

  keyPress(event: any) {
    const pattern = /[0-9]/;
    let inputChar = String.fromCharCode(event.charCode);
    if (event.keyCode != 8 && !pattern.test(inputChar)) {
      event.preventDefault();
    }
  }
}
